import { FavouriteCondition } from 'app/types-shared';
import { searchInAllFieldsDomain } from 'app/area/favourite/constants';

export function returnSearchQuery(conditions: FavouriteCondition[] = []) {
  const searchQueryDomainCondition = conditions.find(item => item?.domain?.v === searchInAllFieldsDomain);
  return searchQueryDomainCondition?.values[0].string;
}
